'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AddEvent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDocumentMeta = require('react-document-meta');

var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);

var _caligramReact = require('caligram-react');

var _FiltersContainer = require('../../containers/FiltersContainer');

var _FiltersContainer2 = _interopRequireDefault(_FiltersContainer);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AddEvent() {
  return _react2.default.createElement(
    'div',
    { className: 'AddEvent' },
    _react2.default.createElement(_reactDocumentMeta2.default, _config2.default.app),
    _react2.default.createElement(
      _caligramReact.Page,
      { title: 'Inscrire une activit\xE9', layout: 'wide' },
      _react2.default.createElement(
        'div',
        { className: 'connectionOptions' },
        _react2.default.createElement(
          'p',
          null,
          'Pour proposer une activit\xE9 au calendrier, vous devez d\u2019abord vous cr\xE9er un compte. Si vous en avez d\xE9j\xE0 un, connectez-vous directement.'
        ),
        _react2.default.createElement(_caligramReact.Button, { title: 'Cr\xE9er un compte', href: 'https://admin.caligram.com/register/22/Calendrier de l\'Universit\xE9 du Qu\xE9bec \xE0 Montr\xE9al', type: 'secondary' }),
        _react2.default.createElement(_caligramReact.Button, { title: 'Connexion', href: 'https://admin.caligram.com', type: 'primary' })
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'filters' },
      _react2.default.createElement(_FiltersContainer2.default, null)
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/AddEvent.js
// module id = 1119
// module chunks = 0